import React from 'react';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { getAreas } from 'api/areas';
import { createAgentArea } from 'api/agents';
import Popup from 'components/Popup';
import Button from 'components/Button';
import SelectInput from 'components/Form/SelectInput';

export default function AgentAddAreasPopup({
    visible,
    setVisible,
    present = []
}) {

    const { agentId } = useParams();
    const cache = useQueryClient();

    const { mutate: update } = useMutation({
        mutationKey: ['createAgentArea'],
        mutationFn: createAgentArea,
        onSuccess: () => {
            cache.invalidateQueries(['agents', agentId]);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error creating agent-area:", error);
        }
    });

    const { data: areas } = useQuery({
        queryKey: ['areas'],
        queryFn: async () => await getAreas({}),
    });


    const selectOptions = areas?.map(area => {
        return {
            value: area._id,
            label: area.name
        }
    });

    function onSubmitHandler(e) {
        e.preventDefault();
        return update({
            id: agentId,
            data: {
                area: e.target.area.value
            }
        });
    }

    return (
        <Popup
            visible={visible}
            setVisible={setVisible}
        >
            <form onSubmit={onSubmitHandler} className='flex flex-col gap-4'>
                {selectOptions &&
                    <SelectInput
                        label="Area"
                        name="area"
                        required
                        options={selectOptions?.filter(element => !present?.includes(element.value))}
                        placeholder="Seleziona un'area"
                    />
                }

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button submit>Conferma</Button>
                </div>
            </form>
        </Popup>
    )
}
